/* eslint-disable react/no-unused-prop-types */
import _ from 'lodash';
import { string } from 'prop-types';
import { t } from '@lingui/macro';

import Filter from '../../page-framework/filter/FilterDecorator';
import { filterPropTypes } from '../../page-framework/filter/FilterPropTypes';
import OptionFilter from '../option-filter/OptionFilter';
import getOptionFilterStateServiceFactory from '../option-filter/OptionFilterStateService';

export const filterId = 'State';
export const filterTitle = t`State`;
export const options = [
    {
        name: t`Open`,
        value: 'Open',
    },
    {
        name: t`Closed`,
        value: 'Closed',
    },
];

function AlertStateFilter({ state, filterActions }) {
    return <OptionFilter options={options} state={state} filterActions={filterActions} />;
}

AlertStateFilter.propTypes = {
    id: filterPropTypes.id,
    title: filterPropTypes.title,
    filterActions: filterPropTypes.filterActions,
    state: string,
};

AlertStateFilter.defaultProps = {
    ...OptionFilter.defaultProps,
    id: filterId,
    title: filterTitle,
};

export default Filter({
    filterId,
    filterStateServiceFactory: getOptionFilterStateServiceFactory(filterTitle, options, 'state', _.lowerCase),
})(AlertStateFilter);
